/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Submitticketsize_Toast_Success3Inputs */

const en_coinvestments_submitticketsize_toast_success3 = /** @type {(inputs: Coinvestments_Submitticketsize_Toast_Success3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ticket size submitted successfully`)
};

/**
* | output |
* | --- |
* | "Ticket size submitted successfully" |
*
* @param {Coinvestments_Submitticketsize_Toast_Success3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_submitticketsize_toast_success3 = /** @type {((inputs?: Coinvestments_Submitticketsize_Toast_Success3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Submitticketsize_Toast_Success3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_submitticketsize_toast_success3(inputs)
});
export { coinvestments_submitticketsize_toast_success3 as "coInvestments_submitTicketSize_toast_success" }